var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selection"},_vm._l((_vm.options),function(option){return _c('div',{class:{ selected: _vm.isSelected(option) },on:{"click":function($event){return _vm.handleClick(option)}}},[_vm._v(_vm._s(option.label))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }